import { isMobile } from 'react-device-detect'
import styled, { css } from 'styled-components'

import { RowFlex, FlexCentered } from 'components/common/genericStyles'
import { Color } from 'constants/color'

const TextStyle = css`
    color: ${Color.white};
    text-transform: capitalize;
    font-weight: bold;
`

export const Container = styled.div`
    ${RowFlex};
    ${FlexCentered};

    background: ${({ color }) => color ?? Color.alternateGreen};

    padding: 0px 8px;
    border-radius: 24px;
    height: 23px;
    width: auto;
    cursor: default;

    ${isMobile &&
        css`
            height: 20px;
        `}

    &:after {
        content: 'Elsewhere';
        ${TextStyle};
        display: none;
    }
`

export const Text = styled.span`
    ${TextStyle};
`
